export const MINIMUM_PAYMENT_TERMS_DAYS = 0
